<div class="px-2 md:px-10 pt-2 md:pt-5 font-bold overflow-y-auto h-74 md:h-88">
  <h1 class="w-full text-center text-3xl mb-10">{{ "maintenancePage.title" | translate }}</h1>

  <h2 class="text-primary_text text-center text-xl mb-10">
    <strong>{{ "maintenancePage.greeting" | translate }}</strong>
    <p>{{ "maintenancePage.text" | translate }}</p>
    <p class="mt-3">{{ "maintenancePage.securityText" | translate }}</p>
    @if (message) {
      <p class="mt-3">{{ message }}</p>
    }
  </h2>
</div>
